/* ============================================================
   MUDNAAZ — Product Card Enhancements
   Adds: Mini ATC below card info (image stays clean).
   Lazy-loads on hover; immediate for first 4 cards.
   Quick View / variant selection handled by mn-quick-view.liquid (V2).
   ============================================================ */
(function () {
  'use strict';

  /* ── Product cache ────────────────────────────────────── */
  const cache = {};
  async function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    try {
      const r = await fetch('/products/' + handle + '.js');
      if (!r.ok) return null;
      cache[handle] = await r.json();
      return cache[handle];
    } catch { return null; }
  }

  function handleFromCard(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  /* ── Add to Cart ──────────────────────────────────────── */
  function addToCart(variantId, btn) {
    const orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓ Added';
      btn.classList.add('is-added');
      // Refresh Dawn cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const bubble = document.querySelector('[data-cart-icon-bubble]');
      if (bubble) bubble.dispatchEvent(new Event('click', { bubbles: true }));
      setTimeout(() => {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2500);
    })
    .catch(() => {
      btn.textContent = 'Try again';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = orig; }, 2000);
    });
  }

  /* ── Card injection ───────────────────────────────────── */
  async function enhanceCard(card) {
    if (card.dataset.mnCe) return;
    card.dataset.mnCe = '1';

    const handle = handleFromCard(card);
    if (!handle) return;

    const product = await fetchProduct(handle);
    if (!product) return;

    const firstAvail = product.variants.find(v => v.available) || product.variants[0];
    if (!firstAvail) return;

    /* — Find the LAST .card__information in the card-wrapper.
         card-product.liquid has two: one inside .card__inner (image overlay, hidden for media cards)
         and one outside .card__inner (title + price, always visible).
         The last one is always the outer/visible one. Insert ATC after it. — */
    if (card.querySelector('.mn-ce-atc-wrap')) return;

    const allInfos = card.querySelectorAll('.card__information');
    const outerInfo = allInfos[allInfos.length - 1];
    if (!outerInfo) return;

    const wrap = document.createElement('div');
    wrap.className = 'mn-ce-atc-wrap';

    const atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.className = 'mn-ce-atc';
    atcBtn.dataset.variantId = firstAvail.id;
    atcBtn.textContent = firstAvail.available ? 'Add to Cart' : 'Sold Out';
    atcBtn.disabled = !firstAvail.available;
    atcBtn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      addToCart(atcBtn.dataset.variantId, atcBtn);
    });

    wrap.appendChild(atcBtn);
    outerInfo.after(wrap);
  }

  /* ── Init ─────────────────────────────────────────────── */
  function init() {
    const cards = document.querySelectorAll('.card-wrapper');
    // First 4: immediate; rest: on hover
    cards.forEach((card, i) => {
      if (i < 4) {
        enhanceCard(card);
      } else {
        card.addEventListener('mouseenter', () => enhanceCard(card), { once: true });
        card.addEventListener('focusin',    () => enhanceCard(card), { once: true });
      }
    });

    // Handle dynamic content (infinite scroll, filters)
    if (window.MutationObserver) {
      new MutationObserver(mutations => {
        mutations.forEach(m => {
          m.addedNodes.forEach(node => {
            if (node.nodeType !== 1) return;
            const newCards = node.matches?.('.card-wrapper')
              ? [node]
              : [...(node.querySelectorAll?.('.card-wrapper') || [])];
            newCards.forEach((card, i) => {
              if (i < 2) enhanceCard(card);
              else card.addEventListener('mouseenter', () => enhanceCard(card), { once: true });
            });
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
